import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import React , {useEffect,useState} from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useShowQuestionQuery,useUpdateQuestionMutation,useGetCourseListQuery,useShowManageModuleQuery} from "../../../Services/api";
export default function UpdateStudent(props) {
    const notify = () => '';
    const validationSchema = Yup.object().shape({
        exam_id: Yup.string().required("exam name fields is required"),
        coursecode: Yup.string().required("course fields is required"),
        slide_section: Yup.string().required("module fields is required"),
        status: Yup.string().required("module content type fields is required"),
        question_name: Yup.string().required("question name fields is required"),
    });
      const {
        data: showQuestion,
        isLoading: isGetLoading,
      } =  useShowQuestionQuery({  params:props['id']});

      const [UpdateQuestion,isLoading] = useUpdateQuestionMutation();
      const getQuestion= showQuestion?.data[0];
      var  defaultValues={
            exam_id:getQuestion?.exam_id,
            coursecode:getQuestion?.coursecode,
            slide_section:getQuestion?.slide_section,
            status:getQuestion?.status,
            question_name:getQuestion?.question_name,
      };
    const methods = useForm({
      mode: "onTouched",
      resolver: yupResolver(validationSchema),
      defaultValues: defaultValues,
    });
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
      } = methods;
       // eslint-disable-next-line react-hooks/exhaustive-deps 
      useEffect(() => {
        reset(defaultValues)
      },[showQuestion]) 
      
        const updateQuestionList = (values,e) => {
            UpdateQuestion({ data: values,param:props['id'] })
            .unwrap()
            .then((payload) => {
                if (payload.status) {
                toast.success(payload.message)
                } else {
                    toast.error(payload.message)
                }
            })
            .catch((error) => {
                toast.error(error.data.message)
            });
            notify();
        };
        const { 
            data: getCourseList        
        } = useGetCourseListQuery({  params:''});
        const [courseCode,setCourseCode] = useState(0);
        const { 
            data: showManageModule        
        } = useShowManageModuleQuery({  params:courseCode});
        
        const findModule=(e)=>{
            setCourseCode(e.target.value);
        }
    return (
        
        <div className="modal fade" id="fullscreenModal">
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Question</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                <section className="section">
                    <div className="card">
                        <div className="card-body">
                        <h5 className="card-title">Update Question</h5>
                        <form onSubmit={handleSubmit(updateQuestionList)} >
                       
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Exam Name</label>
                            <div className="col-sm-10">
                               <select  {...register("exam_id")} className="form-control" >
                                    <option value="">Select Exam Name</option>
                                    <option value="1">Quize Test - Running</option>                                           
                                    <option value="2">Final Exam - Running</option>
                                </select>
                                <span className="text-danger">{errors.exam_id?.message}</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Course</label>
                            <div className="col-sm-10">
                               <select  {...register("coursecode", { required: true })} className="form-control" onChange={findModule}>
                                 <option value="">Select Course</option>                                           
                                    {                            
                                    getCourseList?.data?.map((item) => {
                                        return (
                                            <option key={item.course_id} value={item.course_id}>{item.course_name}</option>                                           
                                            )
                                        })
                                    }
                                </select>
                                <span className="text-danger">{errors.coursecode?.message}</span>

                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Module Name</label>
                            <div className="col-sm-10">
                               <select  {...register("slide_section")} className="form-control" >
                                 <option value="">Select Module</option>                                           

                                {                            
                                   showManageModule?.data?.map((item) => {
                                    return (

                                         <option key={item.lesson_id} value={item.lesson_id}>{item.lesson_name}</option>                                           
                                        )
                                    })
                                }
                                </select>
                                <span className="text-danger">{errors.slide_section?.message}</span>

                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Sub module content type</label>
                            <div className="col-sm-10">
                               <select  {...register("status")} className="form-control" >
                                    <option value="">Select Module Content Type</option> 
                                    <option value="1">First Content in the same module</option>
                                    <option value="2">Second Content in the same module</option>                                           
                                    <option value="3">Third Content in the same module</option>
                                </select>
                                <span className="text-danger">{errors.status?.message}</span>

                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Question</label>
                            <div className="col-sm-10">
                                <input type="name" {...register("question_name")} className="form-control" />
                                <span className="text-danger">{errors.question_name?.message}</span>
                            </div>
                        </div>
                        <div className="modal-footer">
                             {isLoading.status !='pending' ? 
                                <>
                                  <button type="submit" className="btn btn-warning">Save changes</button>
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                </>       
                                :
                                <button  className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                                }
                            </div>
                             
                        </form>
                        </div>
                    </div>
                </section>
            </div>
          </div>
        </div>
      </div>
    );
}